import request from '@/utils/request'

export function getImgUrl() {
    return request({
        url: '/tour-product/imge/getUrl',
        method: 'post'
    })
}

// 发送短信
export function sendSms(params) {
    return request({
        url: '/tour-product/wxuser/sendSms',
        method: 'post',
        params
    })
}

// 获取验证码
export function commonSendSms(data) {
    return request({
        url: '/tour-product/appuser/commonSendSms',
        method: 'post',
        data
    })
}

// 免费领取月卡
export function freeBindCard(data) {
    return request({
        url: '/tour-product/wxusercard/freeBindCard',
        method: 'post',
        data
    })
}

// 验证码校验,代理商制卡
export function verifyCodeCreateCardAndSendSMS(data) {
    return request({
        url: '/tour-product/agent/verifyCodeCreateCardAndSendSMS',
        method: 'post',
        data
    })
}

